import React from "react";

const LOGO_URL = "/assets/claim-beast-logo.png";

// Rhino mark only (uses the same logo image but crops/scales for compact use)
export const RhinoIcon = ({ className = "" }) => (
  <img
    src={LOGO_URL}
    alt="Claim Beast rhino mark"
    className={className}
    style={{ objectFit: "contain", objectPosition: "center top" }}
  />
);

// Full logo (rhino + wordmark)
const RhinoLogo = ({ className = "", size = "default" }) => {
  const heights = {
    sm: "h-12",
    default: "h-16",
    lg: "h-20",
  };
  return (
    <a
      href="#home"
      className={`inline-flex items-center group ${className}`}
      aria-label="Claim Beast Public Adjusters Home"
    >
      <img
        src={LOGO_URL}
        alt="Claim Beast Public Adjusters - Tampa Bay & Riverview FL"
        className={`${heights[size]} w-auto transition-transform group-hover:-translate-y-0.5`}
      />
    </a>
  );
};

export default RhinoLogo;
